



























import Vue from 'vue';
import { pdf } from '@/api';
import { dialogMaxWidth } from '@/constants';
import { AccountExportSettings } from '@/@types/member';

interface Data {
  xlsSettings: AccountExportSettings;
  errorLoading: boolean;
  currentSettings: AccountExportSettings;
  dialogMaxWidth: string;
}

export default Vue.extend({
  name: 'AccountExportTools',
  props: {
    pdf: {
      type: Boolean,
    },
    xls: {
      type: Boolean,
    },
    /**
     * The suffix-less filename.
     */
    filename: {
      type: String,
    },
  },
  data(): Data {
    return {
      xlsSettings: {
        // This is sneaky. It allows parent components to update the link dynamically.
        loading: false,
        extension: '.xlsx',
        type: 'xls',
      },
      errorLoading: false,
      currentSettings: null,
      dialogMaxWidth,
    };
  },
  methods: {
    download(settings): void {
      if (settings.type === 'xls') {
        window.dataLayer.push({
          event: 'xlsDownloadClicked',
        });
      }

      settings.loading = true;
      pdf
        .get(settings.route(), { responseType: 'blob' })
        .then((response) => {
          const link = document.createElement('a');

          // Edge
          if (window.Navigator.msSaveOrOpenBlob) {
            const newBlob = new Blob(response.data);
            window.Navigator.msSaveOrOpenBlob(
              newBlob,
              this.filename + settings.extension,
            );
          } else if (window.navigator.msSaveOrOpenBlob) {
            // IE11
            const newBlob = new Blob([response.data], {
              type: response['content-type'],
            });
            window.navigator.msSaveOrOpenBlob(
              newBlob,
              this.filename + settings.extension,
            );
          } else {
            // Everything else
            link.href = window.URL.createObjectURL(response.data);
          }

          link.download = this.filename + settings.extension;
          document.body.appendChild(link);
          link.click();
          link.remove();

          settings.loading = false;
        })
        .catch(() => {
          settings.loading = false;
          this.currentSettings = settings;
          this.errorLoading = true;
        });
    },
    tryAgain(): void {
      this.errorLoading = false;
      setTimeout(() => {
        this.download(this.currentSettings);
      }, 300);
    },
    dismissError(): void {
      this.errorLoading = false;
    },
    createPdf(): void {
      this.$emit('createPdf');
    },
    createXls(): void {
      this.$emit('createXls');
    },
  },
});
